import { notifications } from '@mantine/notifications';
import { i18n } from 'next-i18next';

export const onShowErrorNotification = () => {
  notifications.show({
    color: 'red',
    title: i18n?.t('authenticationGoogle.notifications.loginFail.title', { ns: 'external-modules' }),
    message: i18n?.t('authenticationGoogle.notifications.loginFail.message', { ns: 'external-modules' })
  });
};

export const onShowSuccessNotification = () => {
  notifications.show({
    color: 'green',
    title: i18n?.t('authenticationGoogle.notifications.loginSuccess.title', { ns: 'external-modules' }),
    message: i18n?.t('authenticationGoogle.notifications.loginSuccess.message', { ns: 'external-modules' })
  });
};

export const onShowLoggedOutNotification = () => {
  notifications.show({
    color: 'yellow',
    title: i18n?.t('authenticationGoogle.notifications.loggedOut.title', { ns: 'external-modules' }),
    message: i18n?.t('authenticationGoogle.notifications.loggedOut.message', { ns: 'external-modules' })
  });
};
